/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ComplianceFormAdditionalFileViewIEnumerableResponse } from '../models';
import { ComplianceFormFileViewResponse } from '../models';
import { ComplianceFormRequest } from '../models';
import { ComplianceFormTipViewIEnumerableResponse } from '../models';
import { ComplianceFormViewIEnumerableResponse } from '../models';
import { FileViewResponse } from '../models';
import { RegeneratedFileLogViewIEnumerableResponse } from '../models';
/**
 * ComplianceFormApi - axios parameter creator
 * @export
 */
export const ComplianceFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadAdditionalFile-stream/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadComplianceFormAdditionalFile/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadEeReportEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV1ComplianceFormDownloadEeReportEeReportIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadEeReport/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet: async (eeReportId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadEeReport/{eeReportId}/{regeneratedFileLogId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet: async (fileId: number, complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet.');
            }
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadFile/{fileId}/{complianceFormId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartAPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV1ComplianceFormDownloadPartAPartAIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadPartA/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet: async (partAId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadPartA/{partAId}/{regeneratedFileLogId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartBPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV1ComplianceFormDownloadPartBPartBIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadPartB/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet: async (partBId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/DownloadPartB/{partBId}/{regeneratedFileLogId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/GetComplianceFormAdditionalFile/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormsPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ComplianceForm/GetComplianceForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormsTipPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ComplianceForm/GetComplianceFormsTip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/GetEeReportFileLogs/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/GetFileAttachments/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetPartAFileLogsPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV1ComplianceFormGetPartAFileLogsPartAIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/GetPartAFileLogs/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetPartBFileLogsPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV1ComplianceFormGetPartBFileLogsPartBIdGet.');
            }
            const localVarPath = `/api/v1/ComplianceForm/GetPartBFileLogs/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceFormApi - functional programming interface
 * @export
 */
export const ComplianceFormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadPartAPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadPartBPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormAdditionalFileViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetComplianceFormsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetComplianceFormsTipPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormTipViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetComplianceFormsTipPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormFileViewResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComplianceFormApi - factory interface
 * @export
 */
export const ComplianceFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): AxiosPromise<string> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadPartAPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadPartBPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormAdditionalFileViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<ComplianceFormViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetComplianceFormsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetComplianceFormsTipPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<ComplianceFormTipViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetComplianceFormsTipPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<RegeneratedFileLogViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormFileViewResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any): AxiosPromise<RegeneratedFileLogViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any): AxiosPromise<RegeneratedFileLogViewIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComplianceFormApi - object-oriented interface
 * @export
 * @class ComplianceFormApi
 * @extends {BaseAPI}
 */
export class ComplianceFormApi extends BaseAPI {
    /**
     * 
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadAdditionalFileStreamComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadEeReportEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} eeReportId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadEeReportEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} fileId 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadFileFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadPartAPartAIdGet(partAId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadPartAPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partAId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadPartAPartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadPartBPartBIdGet(partBId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadPartBPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partBId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormDownloadPartBPartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetComplianceFormAdditionalFileComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetComplianceFormsPost(body?: ComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetComplianceFormsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetComplianceFormsTipPost(body?: ComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetComplianceFormsTipPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV1ComplianceFormGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
}
